@if(normalizedMessages.length) {
<div class="notification-stack">
  @for (m of normalizedMessages; track $index) {
    <div class="notification-bar"
      [class.is-info]="m.type === 'info'"
      [attr.role]="m.type === 'error' ? 'alert' : 'status'"
      [attr.aria-live]="m.type === 'error' ? 'assertive' : 'polite'">

      @if (m.type === 'error') {
        <div class="icons-alert-circle-parent">
          <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
          <div class="message">{{ m.message }}</div>
        </div>
      }

      @if (m.type === 'info') {
        <div class="icons-check-circle-parent">
          <img class="icons-check-circle" src="assets/images/check-circle.svg" alt="Success" />
          <div class="message">{{ m.message }}</div>
        </div>
      }
    </div>
  }
</div>
}

